import { useForm } from 'react-hook-form';
import { useState } from 'react';
import {
  Button,
  Input,
  Textarea,
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/atoms';
import { FormField, StatusModal } from '@/components/molecules';
import { useCreateSupportTicket } from '@/api';

interface FormData {
  title: string;
  description: string;
}

interface AskSellytModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AskSellytModal = ({ isOpen, onClose }: AskSellytModalProps) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      title: '',
      description: '',
    },
  });

  const { mutate: createSupportTicket, isPending } = useCreateSupportTicket(
    () => {
      reset();
      onClose();
      setShowSuccessModal(true);
    }
  );

  const onFormSubmit = (data: FormData) => {
    createSupportTicket({
      title: data.title,
      description: data.description,
    });
  };

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="right" className="w-full sm:max-w-2xl flex flex-col">
        <SheetHeader>
          <SheetTitle>Ask Sellyt</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300 [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-gray-400">
          <form
            onSubmit={handleSubmit(onFormSubmit)}
            className="space-y-4 py-0 px-4"
          >
            <FormField label="Subject *" error={errors.title?.message}>
              <Input
                placeholder="Enter subject"
                {...register('title', {
                  required: 'Subject is required',
                })}
              />
            </FormField>

            <FormField
              label="Description *"
              error={errors.description?.message}
            >
              <Textarea
                placeholder="Enter description"
                rows={4}
                {...register('description', {
                  required: 'Description is required',
                })}
              />
            </FormField>

            <Button
              type="submit"
              className="bg-primary w-full text-white"
              isLoading={isPending}
            >
              Send
            </Button>
          </form>
        </div>
      </SheetContent>

      {/* Success Modal */}
      <StatusModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        type="success"
        title="We'll be in touch shortly!"
        description="Thank you for reaching out. Our support team will get back to you soon."
        buttonText="Close"
        onButtonClick={() => setShowSuccessModal(false)}
      />
    </Sheet>
  );
};
